// extracted by mini-css-extract-plugin
export default {"cache":"cache-efM1","frame":"frame-qnaA","status":"status-pD7M","icon":"icon-aj5H"};